module.exports = __webpack_public_path__ + "img/resized-APP-0005-2.6cb2e2fa.png";